import { useStyles } from '@sravni/react-utils';
import modules_3717c142 from '../styles/Link.module.less.js';

const useLinkStyles = (props) => {
    const { color, strong, className } = props;
    const cx = useStyles(modules_3717c142);
    return cx(className, 'container', {
        [`color-${color}`]: color,
        strong,
    });
};

export { useLinkStyles };
//# sourceMappingURL=useLinkStyles.js.map
